// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 62 ? "fe39b963" : chunkId) + "." + {"62":"c5940704669997e2","139":"e0b8da9815ba2cf2","328":"f2f7d736ef455e2e","733":"6dbfb4642fa86b34"}[chunkId] + ".js";
};